/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-throw-literal */
import service from './service';

export const getSubscription = async (companyId) => {
  if (!companyId) return undefined;

  const response = await service.get(`/subscription/company/${companyId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw `Unable to get plans. ${response.statusText}`;
};

export const updateSubscription = async (subscription) => {
  const response = await service.put(`/subscriptions/${subscription.id}`, subscription);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw `Unable to update the subscription. ${response.statusText}`;
};

export const changeSubscription = async ({ companyId, planId, billingFrequency, addOns }) => {
  const response = await service.put(`/companies/${companyId}/plan`, {
    planId,
    billingFrequency,
    addOns,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw `Unable to update the subscription. ${response.statusText}`;
};

export const managePlan = async () => {
  const response = await service.post(`/subscriptions/portal`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  } else {
    return response;
  }
};

export const chekout = async (payload) => {
  const response = await service.post(`/subscriptions`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw `Unable to process the subscription for the plan. ${response.statusText}`;
};

export default {
  getSubscription,
  updateSubscription,
  changeSubscription,
  managePlan,
  chekout,
};
